import React from "react";
import { useSelector } from "react-redux";
import { dark_mode } from "../../Utility/constants";
import "./TextInput.css";
// import {AiOutlineUser} from 'react-icons/ai'

const TextInput = (props) => {
  const mode = useSelector(state => state.mode)

  return (
    <div
      style={{
        width: props.width ? props.width : "100%",
        marginLeft: props.marginLeft ? props.marginLeft : null,
        alignItems: props.icon ? "flex-end" : "center",
        background: mode === dark_mode ? '#EE31AF' : "#f0f0f3 0% 0% no-repeat padding-box",
        boxShadow: mode === dark_mode ? '0px 0px 30px #365eba' : '3px 3px 30px #7a7878',
        border: mode === dark_mode ? 'none' : '1px solid #E6E6E6',
        opacity: 1,
        borderRadius: '14px'
      }}
      className="inputHolder"
    >
      {props.img ? <img src={props.img}></img> : props.icon ? props.icon : null}
      < input
        required={props.required ? props.required : false}
        type={props.type ? props.type : "text"}
        disabled={props.disabled}
        placeholder={props.placeholder}
        style={{
          textAlign: props.align,
          fontWeight: props.fontWeight ? props.fontWeight : "normal",
          letterSpacing: props.letterSpacing ? props.letterSpacing : "normal",
          color: props.color ? props.color : "#fffff",
          backgroundColor: mode === dark_mode ? '#EE31AF' : '#f0f0f3'
        }}
        value={props.value}
        className="input"
        type={props.type}
        onChange={(e) => {
          if (props.type === "file") {
            props.onChange(e.target.files[0]);
          } else {
            props.onChange(e.target.value);
          }
        }}
      ></input >
    </div >
  );
};

export default TextInput;
